import React, { useState, useEffect } from 'react';
import './CirclePoint.scss';

const CirclePoint = ({ item }) => {
  const [color, setColor] = useState('');
  const [colorMeio1, setColorMeio1] = useState('');
  const [colorMeio2, setColorMeio2] = useState('');
  const [colorMeio3, setColorMeio3] = useState('');
  const [colorFim, setColorFim] = useState('');

  useEffect(() => {
    setColor('');
    setColorMeio1('');
    setColorMeio2('');
    setColorMeio3('');
    setColorFim('');

    if (item >= 1 && item <= 2) {
      setColor('#F15F52');
    }

    if (item >= 3 && item <= 4) {
      setColor('#FFAA00');
      setColorMeio1('#FFAA00');
    }

    if (item >= 5 && item <= 6) {
      setColor('#FFAA00');
      setColorMeio1('#FFAA00');
      setColorMeio2('#FFAA00');
    }

    if (item >= 7 && item <= 9) {
      setColor('#FFAA00');
      setColorMeio1('#FFAA00');
      setColorMeio2('#FFAA00');
      setColorMeio3('#FFAA00');
    }

    if (item >= 10) {
      setColor('#22DF8D');
      setColorMeio1('#22DF8D');
      setColorMeio2('#22DF8D');
      setColorMeio3('#22DF8D');
      setColorFim('#22DF8D');
    }
  }, [item]);

  return (
    <div className="container-circle">
      <div className="circle-point" style={{ backgroundColor: color }} />
      <div className="circle-point" style={{ backgroundColor: colorMeio1 }} />
      <div className="circle-point" style={{ backgroundColor: colorMeio2 }} />
      <div className="circle-point" style={{ backgroundColor: colorMeio3 }} />
      <div className="circle-point" style={{ backgroundColor: colorFim }} />
    </div>
  );
};

export default CirclePoint;
